import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getAsignaciones = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/asignaciones?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearAsignacion = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;

        const {data}  = await Axios.post(
            '/asignaciones', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateAsignacion = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/asignaciones/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateAsignacionAuto = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/asignaciones/auto/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

    export const updateAsignacionFinaliza = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/asignaciones/finaliza/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

    export const updateAsignacionDatos = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/asignaciones/datos/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteAsignacion = (Id) => Axios.delete(`/asignaciones/${Id}`);

  export const getAutorizar = async ( fechaStart,fechaEnd , estado , numeroSolicitud, centroCosto) => {
    try {
        const userInfo = fetchUser();

        const {data}  = await Axios.get(
            `/asignaciones/autorizar?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&estado=${estado}&numeroSolicitud=${numeroSolicitud}&centroCosto=${centroCosto}`);
        return  data;
    } catch (error) {
    return Promise.reject(error);
    }
    };

  export const getAsignacionesFiltros = async ( fechaStart,fechaEnd , estado , numeroSolicitud, centroCosto) => {
    try {
        const userInfo = fetchUser();

        const {data}  = await Axios.get(
            `/asignaciones?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&estado=${estado}&numeroSolicitud=${numeroSolicitud}&centroCosto=${centroCosto}`);
        return  data;
    } catch (error) {
    return Promise.reject(error);
    }
    };